import React from 'react';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';

import configureStore from './configureStore';

import { logAppSession } from './actionCreators/auth';
import { fetchFeatureFlagsRequest } from './actionCreators/featureFlags';
import { getOrgThemeRequest } from './actionCreators/orgTheme';
import { getCustomAppRequest } from './actionCreators/customApp';
import { APP_PRIMARY_COLOR, APP_PRIMARY_FONT } from './theme/constants';
import { Route, Routes, Router } from 'react-router-dom';
import SignIn from './containers/Auth/SignIn';
import Account from './containers/Account';
import SignInWithMagicLink from './containers/Auth/SignInWithMagicLink';
import PrivateRoute from './routes/PrivateRoute';
import Feed from './components/Feed/Feed';
import UserProfile from './containers/OnBoarding/UserProfile';
import PrivacyAndTerms from './containers/PrivacyAndTerms';
import EditProfile from './containers/EditProfile';
import Activity from './containers/Activity';
import Communities from './containers/Communities';
import CommunityDetails from './containers/CommunityDetails';
import Home from './containers/Home';
import Events from './containers/Events';
import EventDetails from './containers/EventDetails';
import AskAuntyOrUncle from './containers/AskAuntyOrUncle';
import WorshipLocations from './containers/WorshipLocations';
import WorshipLocationDetails from './containers/WorshipLocationDetails';
import Content from './containers/Content';
import TranslationTool from './containers/TranslationTool';
import Notifications from './components/Notifications/Notifications';
import { Engage, SearchOrganisations, SingleChallenge } from './containers';
import LearningTestContainer from './containers/LearningTestContainer';
import ManageGroups from './components/ManageGroups/ManageGroup';
import Knowledgebase from './components/Knowledgebase/Knowledgebase';
import KnowledgebaseDetails from './components/Knowledgebase/KnowledgebaseDetails';
import EmployeeOnboarding from './containers/EmployeeOnboarding';
import CollegueProfile from './components/CollegueProfile';
import GlobalAlerts from './containers/global/GlobalAlerts';
import GlobalPreloaders from './containers/global/GlobalPreloaders';
import AuntyOrUncleProfile from "./containers/AskAuntyOrUncle/Profile";

// Create redux store with history
const initialState = {};
const history = createBrowserHistory();
const store = configureStore(initialState, history);
const host = window.location.host;

store.dispatch(logAppSession());
store.dispatch(fetchFeatureFlagsRequest());
store.dispatch(getOrgThemeRequest());
if (
  host !== 'app-dev.engage4.com' &&
  host !== 'app-uat.engage4.com' &&
  host !== 'app.engage4.com'
) {
  store.dispatch(
    getCustomAppRequest({
      web_url: window.location.host,
    }),
  );
}
document.body.style.setProperty(
  '--primary-color',
  localStorage.getItem('primary-color') || APP_PRIMARY_COLOR,
);
document.body.style.setProperty(
  '--primary-font',
  localStorage.getItem('primary-font') || APP_PRIMARY_FONT,
);

const CustomRouter = ({ basename, children, history }) => {
  const [state, setState] = React.useState({
    action: history.action,
    location: history.location,
  });

  React.useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      basename={basename}
      children={children}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
};

const AppRoutesV2 = () => (
  <Provider store={store}>
    <GlobalPreloaders />
    <CustomRouter history={history}>
      <Routes>
        {/* Private Auth Routes */}
        <Route exact path="/" element={<PrivateRoute />}>
          <Route path="/home" element={<Home />} />
          <Route path="/communities" element={<Communities />} />
          <Route path="/content" element={<Content />} />
          <Route path="/events" element={<Events />} />
          <Route path="/translation_tool" element={<TranslationTool />} />
          <Route path="/events/:id" element={<EventDetails />} />
          <Route path="/worship-locations" element={<WorshipLocations />} />
          <Route path="/worship-locations/:id" element={<WorshipLocationDetails />} />
          <Route path="/communities/:id" element={<CommunityDetails />} />
          <Route path="/ask-aunty-or-uncle" element={<AskAuntyOrUncle />} />
          <Route path="/ask-aunty-or-uncle/profile" element={<AuntyOrUncleProfile />} />
          <Route path="/" element={<Feed key="feedAll" />} />
          <Route path="/set" element={<UserProfile />} />
          <Route path="/onboarding" element={<UserProfile />} />
          <Route exact path="/edit" element={<EditProfile />} />
          <Route path="/privacy-policy" element={<PrivacyAndTerms />} />
          <Route path="/privacy-terms" element={<PrivacyAndTerms />} />
          <Route path="/existing-account" element={<Account />} />
          <Route path="/explore" element={<Activity />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/search" element={<SearchOrganisations />} />
          <Route path="/engage" element={<Engage />} />
          <Route path="/learning/:learningId" element={<LearningTestContainer />} />
          <Route path="/users/:userId" element={<CollegueProfile />} />
          <Route path="/engage/:engageId" element={<SingleChallenge />} />
          <Route path="/feed/:postId" element={<Feed key="feedSingle" />} />
          <Route path="/group-feed/:groupId" element={<Feed />} />
          <Route path="/manage-group/:groupId" element={<ManageGroups />} />
          <Route path="/knowledgebase" element={<Knowledgebase />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/knowledgebase-item/:id" element={<KnowledgebaseDetails />} />
          <Route path="/employee_onboarding" element={<EmployeeOnboarding />} />
        </Route>
        {/* PublicRoutes */}
        <Route exact path="/auth" element={<SignIn />} />
        <Route exact path="/:orgslug/auth" element={<SignIn />} />
        <Route path="/account" element={<Account />} />
        <Route path="/token_auth/:token" element={<SignInWithMagicLink />} />
      </Routes>
    </CustomRouter>
    <GlobalAlerts />
  </Provider>
);

export default AppRoutesV2;
